import { BaseProduct } from './BaseProduct';
import { GlossaryText, ENTRY_TYPES } from './GlossaryText';

class Product extends BaseProduct {
  static buildCharacteristic(data) {
    const characteristics = data.characteristics.map(char => ({
      id: char.id,
      key: char.key,
      value: char.value.map(value => new GlossaryText(value)),
      featured: char.featured,
      visible: char.visible,
    }));
    return {
      id: data.id,
      name: data.name,
      characteristics,
    };
  }

  constructor(params) {
    super(params);
    this.characteristics = (params.characteristics || []).map(Product.buildCharacteristic);
    // Artificially add brand and model as characteristics
    if (params.brand && params.model) {
      this.characteristics.unshift({
        id: `${params.brand}-${params.model}`,
        name: 'Modelo',
        characteristics: [
          {
            key: 'Marca',
            value: [
              new GlossaryText({
                entries: [
                  {
                    entryType: ENTRY_TYPES.PLAIN_TEXT,
                    text: params.brand,
                  },
                ],
              }),
            ],
          },
          {
            key: 'Modelo',
            value: [
              new GlossaryText({
                entries: [
                  {
                    entryType: ENTRY_TYPES.PLAIN_TEXT,
                    text: params.model,
                  },
                ],
              }),
            ],
          },
        ],
      });
    }
    this.images = params.images;
    this.stockLevelLastUpdate = new Date(params.stockLevelLastUpdate);
    this.serviceAvailabilityText = params.serviceAvailabilityText;
    this.serviceMessage = params.serviceMessage;
    this.serviceProduct = params.serviceProduct ? new Product(params.serviceProduct) : null;
  }
}

export { Product };



// WEBPACK FOOTER //
// ./src/models/Product.js